<script setup lang="ts">
/**
 * Uppercase section label + bordered list wrapper.
 *
 * Wraps the repeated pattern of a small uppercase tracking label above
 * a bordered, separated SbList. Caller provides list items via the default slot.
 * Visibility (v-if) is the caller's responsibility.
 *
 * @example
 * ```vue
 * <LabeledSection title="Lent Out" :count="loans.length">
 *   <LoanListItem v-for="loan in loans" :key="loan.id" :loan="loan" />
 * </LabeledSection>
 * ```
 */

import { SbList } from "@unio/saltbox-ui"

defineProps<{
  /** Section heading text, e.g. "Lent Out", "Active Loans" */
  title: string
  /** Optional count shown in parentheses after the title */
  count?: number
}>()
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-muted text-xs font-medium tracking-wide uppercase">
      {{ title }}<template v-if="count != null"> ({{ count }})</template>
    </span>
    <SbList bordered separator>
      <slot />
    </SbList>
  </div>
</template>
